import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';
import debounce from 'debounce';

// for the slider inside the prefooter block
document.addEventListener('DOMContentLoaded', function () {
  class BlockPrefooter extends HTMLElement {
    constructor() {
      super();
      // elements
      this.keenSlider = null;
      this.slider = this.querySelector('.keen-slider');
    }
    connectedCallback() {
      // state
      this.slideByViews = 4;
      // bindings
      this.bndHandleResize = debounce(this.handleResize.bind(this), 250);
      // events
      this.onLoad();
      window.addEventListener('resize', this.bndHandleResize);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.bndHandleResize);
      if (this.keenSlider.destroy) this.keenSlider.destroy();
    }
    onLoad() {
      this.initKeen();
    }
    handleResize() {
      if (window.matchMedia("(min-width: 1200px)").matches) {
        this.slideByViews = 5;
      } else {
        this.slideByViews = 2;
      }
    }
    initKeen() {
      if (!this.slider) return;
      this.keenSlider = new KeenSlider(this.slider, {
        loop: true,
        mode: 'free-snap',
        slides: {
          origin: 'center',
          perView: 'auto',
          spacing: 10
        },
        created: () => {
          this.slider.classList.add('is-ready');
        }
      }, [slider => {
        let timeOut;
        const clearNextTimeout = () => {
          clearTimeout(timeOut);
        };
        const nextTimeout = () => {
          clearTimeout(timeOut);
          timeOut = setTimeout(() => {
            slider.moveToIdx(slider.track.details.abs + this.slideByViews, true, {
              duration: 9000
            });
          }, 4000);
        };
        slider.on('created', nextTimeout);
        slider.on('dragStarted', clearNextTimeout);
        slider.on('animationEnded', nextTimeout);
        slider.on('updated', nextTimeout);
      }]);
    }
  }
  customElements.define('block-prefooter', BlockPrefooter);
});